import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';

import Accordion from '../Accordion/Accordion';
import SchoolDataSimple from '../SchoolDataSimple/SchoolDataSimple';
import { withRtl } from '../hoc';
import style from './SchoolInfoAccordionSr.scss';
import messages from '../../locale/messages';
import { SchoolAccordion } from '../SchoolAccordion';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  accordionPerformance: {
    id: 'schoolinfo.accordionPerformance',
    defaultMessage: 'Performance',
    description: 'Accordion label for school performance',
  },
  accordionAcademics: {
    id: 'schoolinfo.accordionAcademics',
    defaultMessage: 'Academics',
    description: 'Accordion label for school Academics',
  },
  accordionActivities: {
    id: 'schoolinfo.accordionActivities',
    defaultMessage: 'Activities',
    description: 'Accordion label for school Activities',
  },
  accordionOtherFeatures: {
    id: 'schoolinfo.accordionOtherFeatures',
    defaultMessage: 'Other Features',
    description: 'Accordion label for school Other Features',
  },
  accordionAffiliatedSchools: {
    id: 'schoolinfo.accordionAffiliatedSchools',
    defaultMessage: 'Affiliated Schools',
    description: 'Accordion label for school Affiliated Schools',
  },
  accordionAccessibility: {
    id: 'schoolinfo.accordionAccessibility',
    defaultMessage: 'Accessibility',
    description: 'Accordion label for school Accessibility',
  },
  accordionOpenHouses: {
    id: 'schoolinfo.accordionOpenHouses',
    defaultMessage: 'Open Houses & Information Sessions',
    description: 'Accordion label for school Open Houses & Information Sessions',
  },
  accordionMoreInfo: {
    id: 'schoolinfo.accordionMoreInfo',
    defaultMessage: 'More Info',
    description: 'More Info',
  },
  schoolDataELLPrograms: {
    id: 'schoolinfo.schoolDataELLPrograms',
    defaultMessage: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
    description: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
  },
  schoolDataLangaugeCourses: {
    id: 'schoolinfo.schoolDataLangaugeCourses',
    defaultMessage: 'LANGUAGE COURSES',
    description: 'LANGUAGE COURSES',
  },
  schoolDataAPCourses: {
    id: 'schoolinfo.schoolDataAPCourses',
    defaultMessage: 'ADVANCED PLACEMENT (AP) COURSES',
    description: 'ADVANCED PLACEMENT (AP) COURSES',
  },
  schoolDataAdvancedCourses: {
    id: 'schoolinfo.schoolDataAdvancedCourses',
    defaultMessage: 'ADVANCED COURSES',
    description: 'ADVANCED COURSES',
  },
  schoolDataDiplomaEndorsements: {
    id: 'schoolinfo.schoolDataDiplomaEndorsements',
    defaultMessage: 'DIPLOMA ENDORSEMENTS',
    description: 'DIPLOMA ENDORSEMENTS',
  },
  schoolDataSports: {
    id: 'schoolinfo.schoolDataSports',
    defaultMessage: 'SCHOOL SPORTS',
    description: 'SCHOOL SPORTS',
  },
  schoolDataSportsCoed: {
    id: 'schoolinfo.schoolDataSportsCoed',
    defaultMessage: 'PSAL SPORTS - COED',
    description: 'PSAL SPORTS - COED',
  },
  schoolDataSportsGirls: {
    id: 'schoolinfo.schoolDataSportsGirls',
    defaultMessage: 'PSAL SPORTS - GIRLS',
    description: 'PSAL SPORTS - GIRLS',
  },
  schoolDataSportsBoys: {
    id: 'schoolinfo.schoolDataSportsBoys',
    defaultMessage: 'PSAL SPORTS - BOYS',
    description: 'PSAL SPORTS - BOYS',
  },
  schoolStatsGraduate: {
    id: 'schoolinfo.schoolStatsGraduate',
    defaultMessage: 'of students graduate in four years',
    description: 'percentage of students of graduate. A percent precedes this string (ie 76%) ',
  },
  schoolStatsEnrollCollege: {
    id: 'schoolinfo.schoolStatsEnrollCollege',
    defaultMessage: 'of students enroll in college or career programs',
    description:
      'percentage of students of enroll in college or career programs. A percent precedes this string (ie 76%) ',
  },
  schoolStatsAttendance: {
    id: 'schoolinfo.schoolStatsAttendance',
    defaultMessage: 'student attendance',
    description: 'percentage of student attendance. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSaftey: {
    id: 'schoolinfo.schoolStatsSaftey',
    defaultMessage: 'of students feel safe in the hallways, bathrooms, locker room, and cafeteria',
    description: 'percentage of students who feel safe. A percent precedes this string (ie 76%) ',
  },
  schoolStatsVariety: {
    id: 'schoolinfo.schoolStatsVariety',
    defaultMessage:
      'of students feel that this school offers a wide enough variety of programs, classes, and activities to keep them interested in school',
    description:
      'percentage of student who like the variety the school offers. A percent precedes this string (ie 76%) ',
  },
  secondaryWebsite: {
    id: 'schoolinfo.secondaryWebsite',
    defaultMessage: 'See the School Quality Snapshot',
    description: 'Text for link to school quality snapshot',
  },
  accordionAccessibilityMoreInfo: {
    id: 'schoolinfo.accordionAccessibilityMoreInfo',
    defaultMessage: 'Accessibility More Informatiion',
    description: 'Accordion label for Accessibility More Information',
  },
  accordionBAPHelpText: {
    id: 'schoolinfo.accordionBAPHelpText',
    defaultMessage: 'For more details and the most up to date building accessibility information, please view the:',
    description: 'Accordion label for BAP Help Text',
  },
});

class SchoolInfoAccordionSr extends PureComponent {
  static defaultProps = {
    otherFeatures: [],
    affiliatedSchools: [],
    loggedIn: false,
  };
  static propTypes = {
    academics: PropTypes.shape({
      ell: PropTypes.arrayOf(PropTypes.shape({})),
      languageClasses: PropTypes.arrayOf(PropTypes.shape({})),
      apCourses: PropTypes.arrayOf(PropTypes.shape({})),
      diplomaEndorsements: PropTypes.arrayOf(PropTypes.shape({})),
      electivesDescription: PropTypes.string,
      opportunities: PropTypes.shape([]),
      performance: PropTypes.shape({
        graduation: PropTypes.number,
        enrollCollegeCareer: PropTypes.number,
        saftey: PropTypes.number,
        attendance: PropTypes.number,
        variety: PropTypes.number,
      }).isRequired,
    }).isRequired,
    accessibility: PropTypes.string.isRequired,
    accordionAnalyticsClick: PropTypes.func.isRequired,
    activities: PropTypes.shape({
      activities: PropTypes.arrayOf(PropTypes.shape({})),
      sportsBoys: PropTypes.arrayOf(PropTypes.shape({})),
      sportsCoed: PropTypes.arrayOf(PropTypes.shape({})),
      sportsGirls: PropTypes.arrayOf(PropTypes.shape({})),
      sportsDescription: PropTypes.string,
      activitiesDescription: PropTypes.string,
    }).isRequired,
    openHouses: PropTypes.string.isRequired,
    performance: PropTypes.shape({
      graduation: PropTypes.number,
      enrollCollegeCareer: PropTypes.number,
      attendance: PropTypes.number,
      saftey: PropTypes.number,
      variety: PropTypes.number,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    otherFeatures: PropTypes.arrayOf(PropTypes.shape({})),
    affiliatedSchools: PropTypes.arrayOf(PropTypes.shape({})),
    loggedIn: PropTypes.bool,
    bapurl: PropTypes.string,
  };

  getAcademicOpportunities = () => {
    const { academics } = this.props;
    const academicsList = academics.opportunities.map(academicItem => (
      <li key={academicItem.name}>{academicItem.name}</li>
    ));
    return <ul className={style.disc}>{academicsList}</ul>;
  };

  getOtherInfo = (listItems, title) => {
    if (!listItems || listItems.length === 0) {
      return null;
    }

    const itemContents = listItems.map(item => item.name).join(', ');

    return <SchoolDataSimple title={title} stat={itemContents} />;
  };

  getTextInformation = (text, title) => {
    if (text) {
      return <SchoolDataSimple title={title} stat={text} />;
    }
    return null;
  };

  getOtherFeatures = () => {
    const { otherFeatures } = this.props;
    const otherFeaturesList = otherFeatures.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{otherFeaturesList}</ul>;
  };

  getAffiliatedSchools = () => {
    const { affiliatedSchools } = this.props;
    const affiliatedSchoolsList = affiliatedSchools.map(item => <li key={item}>{item}</li>);
    return <ul className={style.disc}>{affiliatedSchoolsList}</ul>;
  };

  getStatDisplay = (statistic, displayString) => {
    if (!statistic) {
      return null;
    }
    return (
      <li>
        <span className={style.stat}>{statistic}%</span> {displayString}
      </li>
    );
  };

  getBAP = (bapurl) => {
    const { intl } = this.props
    if (bapurl) {
      return (
        <li>
          {customisedIntlFormatMessage(intl, localMessages.accordionBAPHelpText)}{' '}
          <a target="_blank" rel="noopener" href={bapurl}>Building Accessibility Profile</a>
        </li>
      );
    }
    return null
  };

  getAccessibilityMoreInfo = () => {
    const { school } = this.props;
    const { accessibility_more_info } = school;
    if (!accessibility_more_info) {
      return null;
    }
    const AccessibilityTypeList = accessibility_more_info.split(',').map(AccessibilityTypeItem => (
      <li key={AccessibilityTypeItem}>{AccessibilityTypeItem}</li>
    ));
    return <ul className={style.disc}>{AccessibilityTypeList}</ul>;
  };

  /* eslint-disable react/no-danger */
  render() {
    const { accordionAnalyticsClick, intl } = this.props;
    const { affiliatedSchools, accessibility, bapurl } = this.props;

    // Distinct filter labels for middle school

    return (
      <div className={style.root}>
        <SchoolAccordion
          {...this.props}
          style={style}
        ></SchoolAccordion>
        {affiliatedSchools && affiliatedSchools.length > 0 && (
          <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAffiliatedSchools)} analytics={accordionAnalyticsClick}>
            <div className={style.schoolDataWrapper}>{this.getAffiliatedSchools()}</div>
          </Accordion>
        )}
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAccessibility)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            <ul>
                <li>{accessibility}</li>
                {this.getBAP(bapurl)}
                {this.getAccessibilityMoreInfo() && (<SchoolDataSimple title={customisedIntlFormatMessage(intl, localMessages.accordionAccessibilityMoreInfo)} stat={this.getAccessibilityMoreInfo()} ></SchoolDataSimple>)}
            </ul>
            </div>
        </Accordion>
      </div>
    );
  }
}

export { SchoolInfoAccordionSr };
export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
)(SchoolInfoAccordionSr);
